import PropTypes from "prop-types"
import React, { useState, useMemo } from "react"
import { Box, TextField, MenuItem, CircularProgress } from "@material-ui/core"
import logo from "../../../../assets/images/crewmama_logo_plain.svg"
import useStyles from "./styles"
import { useDispatch } from "react-redux"
import { updateGeneralDataProperties } from "../../../../actions/billing"
import { openSnackBar } from "../../../../actions/snack-bar"
import { updateSolo } from "../../../../actions/solos"


import crewMamaLogo from "../../../../assets/images/crewmama_brand.png"
import gttLogo from "../../../../assets/images/gtt.png"
import adeskLogo from "../../../../assets/images/adesk.jpg"
import mcsLogo from "../../../../assets/images/mcs_logo.jpg"



const paymentTerms = [
  {
    value: 1,
    title: "Net 90",
  },
  {
    value: 2,
    title: "Net 60",
  },
  {
    value: 5,
    title: "Net 45",
  },
  {
    value: 3,
    title: "Net 30",
  },
  {
    value: 4,
    title: "Net 15",
  }
]

const BillingClientTerms = ({ data = {}, setData = () => { }, ...props }) => {
  const [loading, setLoading] = useState(false)
  const classes = useStyles()
  const dispatch = useDispatch()

  const soloType = window.location.pathname.includes("solo")

  const { id: shootId, invoice_id: soloId, payment_terms } = data

  // gets client logo cloudinary url, if not tries users org logo cloudinary url (CM, Adesk, etc.)
  // if neither, falls back to asset Crew Mama image (for now)
  const loadedLogo = useMemo(
    () => {
      if (data && data.client_company_logo_image) {
        return JSON.parse(data.client_company_logo_image).url
      } else if (data && data.company_logo_image) {
        return JSON.parse(data.company_logo_image).url
      }
    },
    [data]
  )

  // const logos = {
  //   crewmamaLogo: crewMamaLogo,
  //   gttLogo: gttLogo,
  //   adeskLogo: adeskLogo,
  //   mcsLogo: mcsLogo,
  // }


  // const loadedLogo = useMemo(
  //   () => {
  //     if (data && data.crewmama_or_gtt) {
  //       return logos[`${data.crewmama_or_gtt}Logo`]
  //     } else {
  //       return null
  //     }
  //   },
  //   [data]
  // )




  const handleChange = (e, selectProps) => {
    const termsValue = e.target.value
    const termsTitle = selectProps.props.children
    setLoading(true)
    if (soloType) {
      // do something else
      // different call for solos
      let newData = {
        payment_terms: termsValue,
        payment_terms_name: termsTitle,
      }
      dispatch(updateSolo("invoice", soloId, newData))
        .then(() => {
          setLoading(false)
          setData({
            ...data,
            payment_terms: termsValue,
            payment_terms_name: termsTitle,
          })
        })
        .catch(err => {
          console.log(err)
          setLoading(false)
          dispatch(openSnackBar({ message: `Error changing payment terms` }))
        })
    } else {
      dispatch(
        updateGeneralDataProperties(
          {
            payment_terms: termsValue,
            payment_terms_name: termsTitle,
          },
          shootId
        )
      )
        .then(() => {
          setLoading(false)
        })
        .catch(err => {
          setLoading(false)
          dispatch(openSnackBar({ message: err.message }))
        })
    }
  }

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      m={2}
    >
      <img
        src={loadedLogo || logo}
        alt={
          data.client_company_name
            ? `${data.client_company_name}-logo`
            : `client-company-logo`
        }
        style={{ maxHeight: "75px", maxWidth: "200px", objectFit: "contain" }}
      />
      {loading ? (
        <CircularProgress size={24} />
      ) : (
        <TextField
          select
          onChange={(e, selectProps) => handleChange(e, selectProps)}
          value={payment_terms || 5}
          name="payment_terms_name"
          variant="outlined"
          SelectProps={{
            inputProps: {
              classes: {
                root: classes.select,
                icon: classes.icon,
              },
            },
          }}
        >
          {paymentTerms.map((x, i) => (
            <MenuItem key={i} value={x.value}>
              {x.title}
            </MenuItem>
          ))}
        </TextField>
      )}
    </Box>
  )
}

BillingClientTerms.propTypes = {
  data: PropTypes.object,
  setData: PropTypes.func,
}

export default BillingClientTerms
